var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoSoflow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Logo-Soflow_svg__Ebene_1",
  x: 0,
  y: 0,
  viewBox: "0 0 224.6 42"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Logo-Soflow_svg__st4{fill:#fff}.Logo-Soflow_svg__st11{fill:#489f97}")), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_1_",
  x1: 154.43,
  x2: 154.43,
  y1: 39.902,
  y2: 6.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m165.3 6.7-2.2 6.3c4.7 4.8 4.6 12.5-.2 17.2s-12.5 4.6-17.2-.2c-4.6-4.7-4.6-12.3 0-17l-2.2-6.3c-8.2 6-10 17.5-4 25.7s17.5 10 25.7 4 10-17.5 4-25.7c-1.1-1.6-2.4-2.9-3.9-4",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_1_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000177459565496686469530000000882060759628176036_",
  x1: 90.43,
  x2: 90.43,
  y1: 38.99,
  y2: 4.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M79.1 4h22.6v5.6H85.4V18h15.4v5.6H85.4V39h-6.2V4z",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000177459565496686469530000000882060759628176036_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000039120824515569948140000012613793586446558883_",
  x1: 121.285,
  x2: 121.285,
  y1: 38.99,
  y2: 4.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M110.7 4h6.2v29.4h14.9V39h-21.1z",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000039120824515569948140000012613793586446558883_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000159452931941853466040000003235134784676503450_",
  x1: 200.295,
  x2: 200.295,
  y1: 39.01,
  y2: 4.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M176.1 4h6.8l6.6 25.2h.1L197.4 4h6.1l7.7 25.2h.1L218.2 4h6.3l-10.2 35h-5.9l-8.1-26.6h-.1L192.1 39h-5.7z",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000159452931941853466040000003235134784676503450_)"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M49.6 26.3h3.5v15.8h-3.5z",
  className: "Logo-Soflow_svg__st4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000017480206154839300480000012978902351864246200_",
  x1: 0.02,
  x2: 26.69,
  y1: 21.57,
  y2: 21.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.9 17.3c-3.6-1.1-7.8-3-7.6-6V11c0-.5.2-4.4 7.5-4.4 2.5 0 4.2.6 5.2 1.7.6.7 1 1.7 1 2.6h3.7c0-1.8-.7-3.6-1.8-5-1.7-2-4.4-3-8-3-9 0-11.4 5.1-11.4 8.2-.2 4.3 3.3 7.7 10.3 9.7C23 23.8 23 27.7 23 29.4c0 .3-.1 7.1-9.5 7.1-6.5 0-9.8-2.5-9.8-7.6H0c0 3.4 1.3 11.3 13.5 11.3 10.4 0 13.2-7.1 13.2-10.8 0-5.6-4.1-9.5-12.8-12.1",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000017480206154839300480000012978902351864246200_)"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M151.3 0h6.2v17.5h-6.2z",
  className: "Logo-Soflow_svg__st4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000011751424859824984270000012030572427054215833_",
  x1: 51.33,
  x2: 51.33,
  y1: 37.15,
  y2: 2.788,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m41.2 37.1 1.2-3.4c-6.8-4.9-8.3-14.4-3.3-21.2s14.4-8.3 21.2-3.3 8.3 14.4 3.3 21.2c-.9 1.3-2.1 2.4-3.3 3.3l1.2 3.4C70.1 31.6 72.6 20 67 11.3 61.4 2.7 49.9.2 41.2 5.8S30 22.9 35.6 31.6c1.5 2.2 3.4 4.1 5.6 5.5",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000011751424859824984270000012030572427054215833_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000028303935723009939200000003207751876645510053_",
  x1: 154.43,
  x2: 154.43,
  y1: 39.902,
  y2: 6.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m165.3 6.7-2.2 6.3c4.7 4.8 4.6 12.5-.2 17.2s-12.5 4.6-17.2-.2c-4.6-4.7-4.6-12.3 0-17l-2.2-6.3c-8.2 6-10 17.5-4 25.7s17.5 10 25.7 4 10-17.5 4-25.7c-1.1-1.6-2.4-2.9-3.9-4",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000028303935723009939200000003207751876645510053_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000030483893552835127520000010126853877668839827_",
  x1: 90.43,
  x2: 90.43,
  y1: 38.99,
  y2: 4.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M79.1 4h22.6v5.6H85.4V18h15.4v5.6H85.4V39h-6.2V4z",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000030483893552835127520000010126853877668839827_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000013177102916447625220000014539655534085528241_",
  x1: 121.285,
  x2: 121.285,
  y1: 38.99,
  y2: 4.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M110.7 4h6.2v29.4h14.9V39h-21.1z",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000013177102916447625220000014539655534085528241_)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000088134455820715347150000009361787264545827471_",
  x1: 200.295,
  x2: 200.295,
  y1: 39.01,
  y2: 4.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M176.1 4h6.8l6.6 25.2h.1L197.4 4h6.1l7.7 25.2h.1L218.2 4h6.3l-10.2 35h-5.9l-8.1-26.6h-.1L192.1 39h-5.7z",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000088134455820715347150000009361787264545827471_)"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M49.6 26.3h3.5v15.8h-3.5z",
  className: "Logo-Soflow_svg__st11"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000018931349687061937740000007264650033612713902_",
  x1: 13.355,
  x2: 13.355,
  y1: 40.22,
  y2: 2.92,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.9 17.3c-3.6-1.1-7.8-3-7.6-6V11c0-.5.2-4.4 7.5-4.4 2.5 0 4.2.6 5.2 1.7.6.7 1 1.7 1 2.6h3.7c0-1.8-.7-3.6-1.8-5-1.7-2-4.4-3-8-3-9 0-11.4 5.1-11.4 8.2-.2 4.3 3.3 7.7 10.3 9.7C23 23.8 23 27.7 23 29.4c0 .3-.1 7.1-9.5 7.1-6.5 0-9.8-2.5-9.8-7.6H0c0 3.4 1.3 11.3 13.5 11.3 10.4 0 13.2-7.1 13.2-10.8 0-5.6-4.1-9.5-12.8-12.1",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000018931349687061937740000007264650033612713902_)"
  }
}), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M151.3 0h6.2v17.5h-6.2z",
  className: "Logo-Soflow_svg__st11"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Logo-Soflow_svg__SVGID_00000155837283974193456320000016544432537192291995_",
  x1: 51.33,
  x2: 51.33,
  y1: 37.15,
  y2: 2.788,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#04647a"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#003f4f"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m41.2 37.1 1.2-3.4c-6.8-4.9-8.3-14.4-3.3-21.2s14.4-8.3 21.2-3.3 8.3 14.4 3.3 21.2c-.9 1.3-2.1 2.4-3.3 3.3l1.2 3.4C70.1 31.6 72.6 20 67 11.3 61.4 2.7 49.9.2 41.2 5.8S30 22.9 35.6 31.6c1.5 2.2 3.4 4.1 5.6 5.5",
  style: {
    fill: "url(#Logo-Soflow_svg__SVGID_00000155837283974193456320000016544432537192291995_)"
  }
}));
export default SvgLogoSoflow;